/** external */
import _ from "lodash";
import React, { memo } from "react";
import PropTypes from "prop-types";
import { IconButton, Tooltip } from "@toddle-edu/ds-web";
import { JournalAddOutlined, JournalTickOutlined } from "@toddle-edu/ds-icons";
/** internal */
import { useI18n } from "Hooks";

const AddToLibraryButton = memo(props => {
  const {
    isAddedToSchoolLibrary,
    onClick,
    iconVariant,
    iconSize,
    iconType,
  } = props;

  const { t } = useI18n(["common", "worksheet"]);

  const tooltip = isAddedToSchoolLibrary
    ? t("worksheet:question_added_to_school_library")
    : t("common:add_to_label", {
        label: t("common:school_library"),
      });
  const icon = isAddedToSchoolLibrary ? (
    <JournalTickOutlined variant={"success"} />
  ) : (
    <JournalAddOutlined />
  );
  const _onClick = isAddedToSchoolLibrary ? _.noop : onClick;

  return (
    <Tooltip tooltip={tooltip}>
      <IconButton
        dsVersion="2.0"
        variant="neutral"
        type={iconType}
        _legacy_variant={iconVariant}
        size={iconSize}
        icon={icon}
        onClick={_onClick}
        testId="worksheet-addToLibraryButton-addQuestionToLibrary"
        disabled={isAddedToSchoolLibrary}
      />
    </Tooltip>
  );
});

AddToLibraryButton.propTypes = {
  isAddedToSchoolLibrary: PropTypes.bool,
  onClick: PropTypes.func,
  iconVariant: PropTypes.string,
  iconSize: PropTypes.string,
};

AddToLibraryButton.propTypes = {
  iconVariant: "plain",
  iconSize: "x-small",
};

AddToLibraryButton.displayName = "AddToLibraryButton";

export default AddToLibraryButton;
